import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@icon/tag.svg'


const _hoisted_1 = { class: "custom-label__input-wrapper" }
const _hoisted_2 = ["value", "readonly", "maxlength", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_VDropdownWithKeyboardNavigation = _resolveComponent("VDropdownWithKeyboardNavigation")!

  return (_openBlock(), _createBlock(_component_VDropdownWithKeyboardNavigation, {
    id: "customLabel",
    className: `custom-label is-editing ${_ctx.isShowLabel ? 'custom-label__show' : ''} ${_ctx.disabled ? 'pointer-none' : ''}`,
    popperClass: "custom-label__dropdown-poper",
    triggers: [],
    distance: 4,
    shown: !!_ctx.searchLabels.length && _ctx.isShowLabel,
    values: _ctx.searchLabels,
    selectedElementIndex: _ctx.selectedElementIndex,
    isLast: _ctx.isLast,
    autoHide: false,
    disabled: _ctx.disabled,
    placement: "bottom-start",
    onOnSelect: _ctx.onSelectLabel,
    onOnScroll: _ctx.onScroll,
    onSelectedIndexUpdate: _ctx.selectedIndexUpdate
  }, {
    label: _withCtx(({ hideDropdown }) => [
      (_ctx.isShowSticker)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "custom-label__icon-wrapper",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowLabel && _ctx.onShowLabel(...args)))
          }, [
            _createVNode(_component_icon, {
              data: _imports_0,
              fill: true,
              width: "var(--icon-16)",
              height: "var(--icon-16)",
              class: "custom-label__icon"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_Transition, {
          onBeforeLeave: _ctx.hideLabel,
          onEnter: _ctx.showLabel
        }, {
          default: _withCtx(() => [
            (_ctx.isShowLabel)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  ref: "customLabel",
                  style: _normalizeStyle({ width: `${_ctx.inputWidth}px` }),
                  value: _ctx.localLabel,
                  readonly: _ctx.disabled,
                  maxlength: _ctx.LABEL_MAX_LENGTH,
                  class: "custom-label__input",
                  type: "search",
                  name: "item-label-search",
                  "aria-label": "Search labels",
                  autocomplete: "off",
                  placeholder: "Add Label",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInput($event.target.value))),
                  onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
                  onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocusOnLabel && _ctx.onFocusOnLabel(...args))),
                  onKeydown: _withKeys(($event: any) => (_ctx.onKeyDownEnter(hideDropdown)), ["enter"])
                }, null, 44, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["onBeforeLeave", "onEnter"])
      ])
    ]),
    item: _withCtx(({ value }) => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        weight: "400",
        class: "is-ellipsis"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(value), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    "after-list": _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "extra-small",
        weight: "400",
        color: "monochrome-05",
        class: "custom-label__number-of-elements"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.currentLabelsCount) + " from " + _toDisplayString(_ctx.totalLabelsCount), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["className", "shown", "values", "selectedElementIndex", "isLast", "disabled", "onOnSelect", "onOnScroll", "onSelectedIndexUpdate"]))
}